import { useTranslation } from "react-i18next";
// AppLogo is imported by header/index.tsx and other consumers — keep this export stable.
export const AppLogo = () => {
  const { t } = useTranslation(["common"]);

  return (
    <img
      src="/icons/app-full-logo.svg"
      alt={t("common:chrome.app_logo")}
      className="block h-7 w-auto lg:h-10"
    />
  );
};
